import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useStepFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import ReceivedGiftBoxFragment from './fragments/GiftBoxFragment/ReceivedGiftBoxFragment';
import SentGiftBoxFragment from './fragments/GiftBoxFragment/SentGiftBoxFragment';
import GiftMainFragment from './fragments/GiftMainFragment';
import GiftRegisterFragment from './fragments/GiftRegisterFragment';

interface Params {
    type: 'MAIN' | 'CATEGORY' | 'BOX' | 'RECEIVED' | 'SENT' | 'REGISTER';
}

declare module '@stackflow/config' {
    interface Register {
        GiftsActivity: Params;
    }
}

const GiftsActivity: ActivityComponentType<'GiftsActivity'> = ({ params }) => {
    const { type = 'MAIN' } = params;
    const { replaceStep } = useStepFlow('GiftsActivity');
    const { t } = useTranslation('gift');
    let selected = type;
    if (type === 'BOX') selected = 'RECEIVED';
    if (type === 'CATEGORY') selected = 'MAIN';

    return (
        <AppScreen>
            <Header title={t('title')} />
            <TabList variant='line'>
                <TabItem selected={selected === 'MAIN'}
                    onClick={() => replaceStep({ type: 'MAIN' })}
                    aria-label='gift-tab'
                    data-type='main' >
                    {t('tabs.main')}
                </TabItem>
                <TabItem selected={selected === 'RECEIVED'}
                    onClick={() => replaceStep({ type: 'RECEIVED' })}
                    aria-label='gift-tab'
                    data-type='received' >
                    {t('giftBox.received')}
                </TabItem>
                <TabItem selected={selected === 'SENT'}
                    onClick={() => replaceStep({ type: 'SENT' })}
                    aria-label='gift-tab'
                    data-type='sent' >
                    {t('giftBox.sent')}
                </TabItem>
                <TabItem selected={selected === 'REGISTER'}
                    onClick={() => replaceStep({ type: 'REGISTER' })}
                    aria-label='gift-tab'
                    data-type='register' >
                    {t('tabs.register')}
                </TabItem>
            </TabList>

            {selected === 'MAIN' && <GiftMainFragment />}
            {selected === 'RECEIVED' && <ReceivedGiftBoxFragment key='received' />}
            {selected === 'SENT' && <SentGiftBoxFragment key='sent' />}
            {selected === 'REGISTER' && <GiftRegisterFragment />}
        </AppScreen>
    );
};

export default GiftsActivity;
